import Quill from 'quill'

export const CONTINUOUS_LIST_MODULE_NAME = 'continuousList'
export const CONTINUOUS_LIST_CLASS = 'ql-continuous-list'

// SVG icon: a numbered list with a chain link underneath, indicating continuity
export const CONTINUOUS_LIST_ICON = `<svg viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
  <text x="1" y="7" font-size="5.5" font-family="monospace" fill="currentColor">1.</text>
  <line x1="8" y1="4.5" x2="17" y2="4.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
  <text x="1" y="12.5" font-size="5.5" font-family="monospace" fill="currentColor">2.</text>
  <line x1="8" y1="10" x2="17" y2="10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
  <path d="M4 13.5 C4 12.7 4.7 12 5.5 12 L6.5 12 C7.3 12 8 12.7 8 13.5 C8 14.3 7.3 15 6.5 15 L5.5 15 C5.1 15 4.7 14.8 4.4 14.5" stroke="currentColor" stroke-width="1.2" fill="none" stroke-linecap="round"/>
  <path d="M6 14.5 C6 13.7 6.7 13 7.5 13 L8.5 13 C9.3 13 10 13.7 10 14.5 C10 15.3 9.3 16 8.5 16 L7.5 16 C7.1 16 6.7 15.8 6.4 15.5" stroke="currentColor" stroke-width="1.2" fill="none" stroke-linecap="round"/>
</svg>`

interface ContinuousListOptions {
    enabled?: boolean
    onChange?: (enabled: boolean) => void
}

class ContinuousListModule {
    static moduleName = CONTINUOUS_LIST_MODULE_NAME

    private quill: Quill
    private enabled: boolean
    private onChange?: (enabled: boolean) => void

    constructor(quill: Quill, options: ContinuousListOptions = {}) {
        this.quill = quill
        this.enabled = options.enabled ?? false
        this.onChange = options.onChange

        const toolbar = quill.getModule('toolbar') as {
            addHandler: (name: string, fn: () => void) => void
        } | undefined

        toolbar?.addHandler('continuous-list', () => this.toggle())

        this.apply()
    }

    toggle(): void {
        this.enabled = !this.enabled
        this.apply()
        this.onChange?.(this.enabled)
    }

    private apply(): void {
        this.quill.container.classList.toggle(CONTINUOUS_LIST_CLASS, this.enabled)

        // Keep the toolbar button visually active/inactive
        const btn = this.quill.container
            .closest('.sp-quill')
            ?.querySelector<HTMLButtonElement>('.ql-continuous-list')

        if (btn) {
            btn.classList.toggle('ql-active', this.enabled)
        }
    }

    isEnabled(): boolean {
        return this.enabled
    }

    setEnabled(enabled: boolean): void {
        if (this.enabled === enabled) {
            return
        }

        this.enabled = enabled
        this.apply()
    }
}

export default ContinuousListModule
